import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import Layout from "../layouts/layout";
import TemplateList from "../containers/_messageTemplates/templateList";
import TemplateEditorPanel from "../containers/_messageTemplates/templateEditorPanel";
import MESSAGE_TEMPLATES from "../api/services/MESSAGE_TEMPLATES";
import { toast } from "react-toastify";
import styles from "../styles/_screens/messageTemplates.module.scss";

const MessageTemplates = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null); // null = panel closed
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (!token) navigate(paths.login);
  }, [token]);

  useEffect(() => {
    fetchTemplates();
  }, [success]);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const res = await MESSAGE_TEMPLATES.getAll();
      setTemplates(res.data || []);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleToggle = async (id) => {
    try {
      await MESSAGE_TEMPLATES.toggle(id);
      setSuccess((v) => !v);
    } catch (error) {
      toast.error(error?.response?.data?.message || "שגיאה בעדכון התבנית");
    }
  };

  const handleDelete = async (id) => {
    try {
      await MESSAGE_TEMPLATES.remove(id);
      toast.success("התבנית נמחקה בהצלחה");
      setSuccess((v) => !v);
    } catch (error) {
      toast.error(error?.response?.data?.message || "שגיאה במחיקת התבנית");
    }
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.pageHeader}>
          <div>
            <h1 className={styles.pageTitle}>תבניות הודעות</h1>
            <p className={styles.pageSubtitle}>
              ניהול הודעות אוטומטיות לוואטסאפ ו-SMS — תזכורות, אישורים וביטולים
            </p>
          </div>
        </div>

        <TemplateList
          templates={templates}
          loading={loading}
          onEdit={setEditingTemplate}
          onToggle={handleToggle}
          onDelete={handleDelete}
        />
      </div>

      {editingTemplate !== null && (
        <TemplateEditorPanel
          template={editingTemplate}
          onClose={() => setEditingTemplate(null)}
          setSuccess={setSuccess}
        />
      )}
    </Layout>
  );
};

export default MessageTemplates;
